// extracted by mini-css-extract-plugin
module.exports = {"button":"transparent-button_button__Lor7B","button_disabled":"transparent-button_button_disabled__HGDc_"};